import React, { createContext, useContext, useReducer } from "react";

export const StateContext = createContext();

//Preparing The data Layer
export const StateProvider = ({ reducer, initialState, children }) => (
    <StateContext.Provider value={useReducer(reducer, initialState)}>
        {children}
    </StateContext.Provider>
);

//Hook Which allow us to pull information from the data layer
export const useStateValue = () => useContext(StateContext);